import { ApiService } from '../apiService'

export const getProviderEvents = async () => {
  return ApiService.get('/provider_events.json')
}
